export const state = () => ({
  token: null,
  user: null,
  showLogin: false,
  userIP: ''
})
export const mutations = {
  setUser(state,  user) {
    state.user = user
  },
  setToken(state, token) {
    state.token = token
  },
  clearUserData(state) {
    state.token = null
    state.user = null
  },
  setShowLogin(state, showLogin) {
    state.showLogin = showLogin
  },
  SET_USER_IP(state, ip) {
    state.userIP = ip
  }
}
export const actions = {
  async login({ commit }, { username, password, remember }) {
    try {
      const response = await this.$api.post('/login', { username, password })
      if (response.code !== 200) { return response }
      const data = response.data
      const expires = remember ? new Date(Date.now() + 7 * 24 * 60 * 60 * 1000) : null
      this.$cookies.set('hz_token', data.token, { 
        path: '/',
        expires,
        maxAge: remember ? 7 * 24 * 60 * 60 : undefined
      })
      const res = await this.$api.get('/users/info')
      if (res.code !== 200) { return }
      const user = res.data
      commit('setUser', user)
      return { success: true, }
    } catch (err) {
      return { 
        success: false, 
        message: err.response ? err.response.message : '登录失败' 
      }
    }
  },
  logout({ commit }) {
    commit('clearUserData')
    this.$cookies.remove('hz_token')
    this.$router.push('/')
  },
  async initAuth({ commit }) {
    const token = this.$cookies.get('hz_token')
    if (token) {
      try {
        const res = await this.$api.get('/users/info')
        if (res.code !== 200) { return }
        const user = res.data
        commit('setUser', user )
      } catch (err) {
        this.$cookies.remove('hz_token')
      }
    }
  },
  async autoLogin ({ commit }, secret_token) {
    try {
      const response = await this.$api.post('/login', { 'secret_token': secret_token })
      if (response.code !== 200) { return false }
      const data = response.data
      const expires = new Date(Date.now() + 7 * 24 * 60 * 60 * 1000)
      this.$cookies.set('hz_token', data.token, { 
        path: '/',
        expires,
        maxAge: 7 * 24 * 60 * 60
      })
      const res = await this.$api.get('/users/info')
      if (res.code !== 200) { return }
      const user = res.data
      commit('setUser', user )
    } catch (err) {
      this.$cookies.remove('hz_token')
    }
  },
  // 获取用户地址
  async nuxtServerInit({ commit }, { req }) {
    let ip = ''
    if (process.server && req) {
      // 获取真实IP地址
      ip = (
        req.headers['x-forwarded-for'] ||
        req.headers['x-real-ip'] ||
        req.connection.remoteAddress ||
        req.socket.remoteAddress ||
        (req.connection.socket ? req.connection.socket.remoteAddress : null)
      )
      
      // 如果是多个IP，取第一个
      if (ip && ip.includes(',')) {
        ip = ip.split(',')[0].trim()
      }
    }
    commit('SET_USER_IP', ip)
  }
}